import React from 'react';

import ChoiceButtonContents from './ChoiceButtonContents';
import { useAnimationStageContext } from './AnimationStageContext';

const DirectionChoiceButton = () => {
  const { stageKey, getSelectedDirectionChoice } = useAnimationStageContext();

  if (!stageKey) {
    return null;
  }

  const { label, icon } = getSelectedDirectionChoice();

  return (
    <ChoiceButtonContents label={label} id={`${stageKey}-direction-button-choice-contents`}>
      {icon}
    </ChoiceButtonContents>
  );
};

export default DirectionChoiceButton;
